import { Button, Modal } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

interface ModalDeleteRecipientEmailProps {
  isOpen: boolean;
  setOpen: (newValue: boolean) => void;
  onDelete: () => void;
}

export const ModalDeleteRecipientEmail = ({
  isOpen,
  setOpen,
  onDelete,
}: ModalDeleteRecipientEmailProps): JSX.Element => {
  const { t } = useTranslation('common');
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      contentLabel={t('visitor-lookup.modal-delete-recipient-email.title')}
      isOpen={isOpen}
      onClose={handleClose}
    >
      <Modal.Header title={t('visitor-lookup.modal-delete-recipient-email.title')} />
      <Modal.Body>{t('visitor-lookup.modal-delete-recipient-email.description')}</Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={handleClose}>
          {t('visitor-lookup.modal-delete-recipient-email.cancel')}
        </Button>
        <Button
          id="modal-submit-button"
          kind="danger"
          onClick={() => {
            handleClose();
            onDelete();
          }}
        >
          {t('visitor-lookup.modal-delete-recipient-email.delete')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
